import { render, staticRenderFns } from "./rule-settings.vue?vue&type=template&id=0d170450&scoped=true&"
import script from "./rule-settings.vue?vue&type=script&lang=ts&"
export * from "./rule-settings.vue?vue&type=script&lang=ts&"
import style0 from "./rule-settings.vue?vue&type=style&index=0&id=0d170450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d170450",
  null
  
)

export default component.exports